import { render, staticRenderFns } from "./CustomsEntryRegistration.vue?vue&type=template&id=e14232aa"
import script from "./CustomsEntryRegistration.vue?vue&type=script&lang=js"
export * from "./CustomsEntryRegistration.vue?vue&type=script&lang=js"
import style0 from "./CustomsEntryRegistration.vue?vue&type=style&index=0&id=e14232aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports